import React from 'react';
import { ReceivingExpandListTemplate } from 'themes/modules/receiving/pages';
import { ReceivingExpandListViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ReceivingExpandListViewStore(rootStore, componentProps), 'viewStore')
class ReceivingExpandList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ReceivingExpandListTemplate {...this.props} />;
	}
}

export default ReceivingExpandList;



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/ReceivingExpandList.jsx